
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.995","height":"15.996"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1368"}},[_c('g',{attrs:{"data-name":"그룹 1015"}},[_c('g',{attrs:{"data-name":"그룹 1013"}},[_c('path',{attrs:{"data-name":"패스 517","d":"M7.998 2.399a5.6 5.6 0 11-5.6 5.6 5.6 5.6 0 015.6-5.6m0-2.4a8 8 0 108 8 8 8 0 00-8-8z","fill":"#f36628"}})]),_c('g',{attrs:{"data-name":"그룹 1014"}},[_c('path',{attrs:{"data-name":"패스 519","d":"M7.529 11.124a1.2 1.2 0 01-.929-.44L4.32 7.896a1.2 1.2 0 111.857-1.52l1.344 1.643 3.94-4.909a1.2 1.2 0 011.871 1.5l-4.867 6.062a1.2 1.2 0 01-.93.449z","fill":"#f36628"}})])])])])
          )
        }
      }
    